<nav
     class="md:left-0 md:block md:fixed md:top-0 md:bottom-0 md:overflow-y-auto md:flex-row md:flex-nowrap md:overflow-hidden shadow-xl bg-white flex flex-wrap items-center justify-between relative md:w-64 z-10 py-4 px-6">
  <div
       class="md:flex-col md:items-stretch md:min-h-full md:flex-nowrap px-0 flex flex-wrap items-center justify-between w-full mx-auto">
    <!-- Toggler -->
    <button class="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
            type="button" (click)="(1)">
      <i class="fas fa-bars"></i>
    </button>
    <!-- Brand -->
    <a [routerLink]="['/']"
       class="md:block text-left md:pb-2 text-blueGray-600 mr-0 inline-block whitespace-nowrap text-sm uppercase font-bold p-4 px-0">
      <div class="flex justify-center">
        <img src="./assets/img/logo_preto.png" alt="logo" class="w-3/4" />
      </div>
    </a>
    <!-- User -->
    <ul class="md:hidden items-center flex flex-wrap list-none">
      <li class="inline-block relative">
        <!-- notification dropdown -->
      </li>
      <li class="inline-block relative">
        <!-- user dropdown -->
      </li>
    </ul>

    <div
         class="md:flex md:flex-col md:items-stretch md:opacity-100 md:relative md:mt-4 md:shadow-none shadow absolute top-0 left-0 right-0 z-40 overflow-y-auto overflow-x-hidden h-auto items-center flex-1 rounded">

      <!-- Collapse header mobile -->
      <div class="md:min-w-full md:hidden block pb-4 mb-4 border-b border-solid border-blueGray-200">
        <div class="flex flex-wrap">
          <div class="w-6/12">
            <a [routerLink]="['/']"
               class="md:block text-left md:pb-2 text-blueGray-600 mr-0 inline-block whitespace-nowrap text-sm uppercase font-bold p-4 px-0">
              Notus Angular
            </a>
          </div>
          <div class="w-6/12 flex justify-end">
            <button type="button"
                    class="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
                    (click)="(1)">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Search mobile -->
      <form class="mt-6 mb-4 md:hidden">
        <div class="mb-3 pt-0">
          <input type="text" placeholder="Search"
                 class="border-0 px-3 py-2 h-12 border-solid border-blueGray-500 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-base leading-snug shadow-none outline-none focus:outline-none w-full font-normal" />
        </div>
      </form>

      <!-- Divider -->
      <hr class="my-4 md:min-w-full" />

      <!-- MAIN NAV -->
      <ul class="md:flex-col md:min-w-full flex flex-col list-none">
        <li class="items-center">
          <a [routerLink]="['/admin/dashboard']" class="text-xs uppercase py-3 font-bold flex items-end"
             routerLinkActive #adminDashboard="routerLinkActive" [ngClass]="
              adminDashboard.isActive
                ? 'text-amber-600 hover:text-amber-700'
                : 'text-blueGray-700 hover:text-blueGray-500'
            ">
            <ng-icon size="20px" name="heroHome" class="mr-2 text-sm" [ngClass]="
                adminDashboard.isActive ? 'opacity-75' : 'text-blueGray-300'
              "></ng-icon>
            Dashboard
          </a>
        </li>

        <li class="items-center">
          <a [routerLink]="['/admin/members']" class="text-xs uppercase py-3 font-bold flex items-end"
             routerLinkActive #adminMembros="routerLinkActive" [ngClass]="
              adminMembros.isActive
                ? 'text-amber-600 hover:text-amber-700'
                : 'text-blueGray-700 hover:text-blueGray-500'
            ">
            <ng-icon size="20px" name="heroUsers" class="mr-2 text-sm" [ngClass]="
                adminMembros.isActive ? 'opacity-75' : 'text-blueGray-300'
              "></ng-icon>
            Membros
          </a>
        </li>

        <li class="items-center">
          <a [routerLink]="['/admin/companies']" class="text-xs uppercase py-3 font-bold flex items-end"
             routerLinkActive #adminEmpresas="routerLinkActive" [ngClass]="
              adminEmpresas.isActive
                ? 'text-amber-600 hover:text-amber-700'
                : 'text-blueGray-700 hover:text-blueGray-500'
            ">
            <ng-icon size="20px" name="heroBuildingOffice2" class="mr-2 text-sm" [ngClass]="
                adminEmpresas.isActive ? 'opacity-75' : 'text-blueGray-300'
              "></ng-icon>
            Empresas
          </a>
        </li>

        <li class="items-center">
          <a [routerLink]="['/admin/events']" class="text-xs uppercase py-3 font-bold flex items-end"
             routerLinkActive #adminEventos="routerLinkActive" [ngClass]="
              adminEventos.isActive
                ? 'text-amber-600 hover:text-amber-700'
                : 'text-blueGray-700 hover:text-blueGray-500'
            ">
            <ng-icon size="20px" name="heroBuildingStorefront" class="mr-2 text-sm" [ngClass]="
                adminEventos.isActive ? 'opacity-75' : 'text-blueGray-300'
              "></ng-icon>
            Eventos
          </a>
        </li>
      </ul>

      <!-- Divider -->
      <hr class="my-4 md:min-w-full" />

      <!-- SECONDARY NAV -->
      <ul class="md:flex-col md:min-w-full flex flex-col list-none md:mb-4">

        <li class="items-center">
          <a
            [routerLink]="['/admin/users']"
            routerLinkActive
            [routerLinkActiveOptions]="{ exact: false }"
            #adminUsuarios="routerLinkActive"
            class="text-xs uppercase py-3 font-bold flex items-end"
            [ngClass]="
              adminUsuarios.isActive
                ? 'text-amber-600 hover:text-amber-700'
                : 'text-blueGray-700 hover:text-blueGray-500'
            "
          >
            <ng-icon
              size="20px"
              name="heroUser"
              class="mr-2 text-sm"
              [ngClass]="adminUsuarios.isActive ? 'opacity-75' : 'text-blueGray-300'"
            ></ng-icon>
            Usuários
          </a>
        </li>

        <li class="items-center relative" #settingsMenuRoot>
          <button
            type="button"
            (click)="toggleSettingsMenu($event)"
            class="w-full text-left text-xs uppercase py-3 font-bold flex items-center justify-between gap-2 rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-500"
            [ngClass]="
              isSettingsSectionActive()
                ? 'text-amber-600 hover:text-amber-700'
                : 'text-blueGray-700 hover:text-blueGray-500'
            "
            [attr.aria-expanded]="settingsMenuOpen"
            aria-haspopup="true"
          >
            <span class="flex items-end">
              <ng-icon
                size="20px"
                name="heroCog6Tooth"
                class="mr-2 text-sm"
                [ngClass]="isSettingsSectionActive() ? 'opacity-75' : 'text-blueGray-300'"
              ></ng-icon>
              Configurações
            </span>
            <ng-icon
              name="heroChevronDown"
              size="18px"
              class="shrink-0 transition-transform duration-150"
              [ngClass]="settingsMenuOpen ? '-rotate-180' : ''"
            ></ng-icon>
          </button>
          <ul
            *ngIf="settingsMenuOpen"
            class="mt-1 mb-2 pl-4 border-l-2 border-amber-200 ml-2 space-y-0.5"
            role="menu"
          >
            <li>
              <a
                routerLink="/admin/networking-objectives"
                routerLinkActive="text-amber-600 font-bold"
                [routerLinkActiveOptions]="{ exact: false }"
                (click)="closeSettingsMenu()"
                class="block text-xs uppercase py-2 font-semibold text-blueGray-600 hover:text-amber-600"
                role="menuitem"
              >
                Objetivos de Networking
              </a>
            </li>
            <li>
              <a
                routerLink="/admin/training-information-areas"
                routerLinkActive="text-amber-600 font-bold"
                [routerLinkActiveOptions]="{ exact: false }"
                (click)="closeSettingsMenu()"
                class="block text-xs uppercase py-2 font-semibold text-blueGray-600 hover:text-amber-600"
                role="menuitem"
              >
                Áreas de Informação e Treinamento
              </a>
            </li>
            <li>
              <a
                routerLink="/admin/event-participation-types"
                routerLinkActive="text-amber-600 font-bold"
                [routerLinkActiveOptions]="{ exact: false }"
                (click)="closeSettingsMenu()"
                class="block text-xs uppercase py-2 font-semibold text-blueGray-600 hover:text-amber-600"
                role="menuitem"
              >
                Tipos de Eventos de Interesse
              </a>
            </li>
            <li>
              <a
                routerLink="/admin/categories"
                routerLinkActive="text-amber-600 font-bold"
                [routerLinkActiveOptions]="{ exact: false }"
                (click)="closeSettingsMenu()"
                class="block text-xs uppercase py-2 font-semibold text-blueGray-600 hover:text-amber-600"
                role="menuitem"
              >
                Categorias
              </a>
            </li>
            <li>
              <a
                routerLink="/admin/interests"
                routerLinkActive="text-amber-600 font-bold"
                [routerLinkActiveOptions]="{ exact: false }"
                (click)="closeSettingsMenu()"
                class="block text-xs uppercase py-2 font-semibold text-blueGray-600 hover:text-amber-600"
                role="menuitem"
              >
                Interesses
              </a>
            </li>
            <li>
              <a
                routerLink="/admin/content-preferences"
                routerLinkActive="text-amber-600 font-bold"
                [routerLinkActiveOptions]="{ exact: false }"
                (click)="closeSettingsMenu()"
                class="block text-xs uppercase py-2 font-semibold text-blueGray-600 hover:text-amber-600"
                role="menuitem"
              >
                Preferências de Conteúdo
              </a>
            </li>
          </ul>
        </li>

        <li class="items-center">
          <a (click)="logout()"
             class="cursor-pointer text-xs uppercase py-3 font-bold flex items-end text-red-400 hover:text-red-600">
            <ng-icon size="20px" name="heroPower" class="mr-2 text-sm"></ng-icon>
            Sair
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>